

import React, { useState  } from 'react'; 
import 'bootstrap/dist/css/bootstrap.min.css';

import styled from "styled-components";
import DeviceUtils from "../../../helper/DeviceUtils"; 
import aboutImg from "../images/about/about.jpg"; 

const HommainView =  styled.div`   
    background-color: #000000;
    height:${props => props.height}px;
    position: relative;  
    overflow:hidden;

    margin-left:${props => props.margin}px;
    margin-right: ${props => props.margin}px; 
    min-width: 980px;
    `;

    
const WRchTxt0 =  styled.div` 
    color: white;
    position: relative;
    margin: ${props => props.marginTop}px  0px 0 0;
    
    padding-left: ${props => props.marginLeft}px;
    padding-right: ${props => props.marginRight}px; 
    left: 0px;
    grid-area: 3 / 1 / 4 / 2;
    justify-self: start;
    align-self: start;  `;
 

const AboutCenterView = () => {

 
    //桌機
    const pRightMargin = 30;

    return (<HommainView margin={(DeviceUtils.isMobile()===true)?0:100} 
     id={"AboutCenterView"}
      style={{paddingTop:`${(DeviceUtils.isMobile()===true)?5:50}px` ,position:'relative'}} 

      height={(DeviceUtils.isMobile()===true)?1500:783}>
 
                <div className={(DeviceUtils.isMobile()===true)?"pl-4 pr-4":"p-0 m-0"}  
                    style={{width:`${(DeviceUtils.isMobile()===true)?window.innerWidth:604}px`}}>

                    <WRchTxt0
                    marginTop={(DeviceUtils.isMobile()===true)?30:0}
                    marginRight={(DeviceUtils.isMobile()===true)?0:pRightMargin}
                    marginLeft={(DeviceUtils.isMobile()===true)?0:(125-pRightMargin)}
                    >
                        {/*{titleArray.map((title,index)=>{*/}
                        {/*    return <H4div  key={index} fontSize={fontSizeNum}>*/}
                        {/*        {title}*/}
                        {/*    </H4div>;*/}
                        {/*})}*/}

                        <h3>
                        SubPro Studio
                        </h3>

                        <p className="newpageP" style={{
                            paddingTop:`${(DeviceUtils.isMobile()===true)?10:0}px`,
                            width:`${(DeviceUtils.isMobile()===true)?window.innerWidth-60:479}px`,
                            fontSize:`${(DeviceUtils.isMobile()===true)?18:18}px`}}>

                            SubPro is a young and dynamic subtitling localization agency. Consists of a group of people who are professional in the localization field. SubPro is born out of the desire to provide high-quality professional services. Our main objective is to offer our clients linguistic solutions and guide them through the entire internationalization process of their products, while offering a unique, personalized touch, competitive rates and timely deliveries.
                            <br/><br/>
                            Recruiting experienced localization freelancers from all over the world. "We know exactly what you need when it comes to localization". We guarantee quality results and customer satisfaction in working with only our best translators, voice talents and editors in our team.
                            <br/><br/>
                            Our mission
                            <br/><br/>
                            To help our customers to construct more effective supply chains and more valuable products, as well as broader global audiences.
                        </p>
 

                    </WRchTxt0>
                </div>

                {(DeviceUtils.isMobile()===true)?<div
                style={{
                    width:`${window.innerWidth}px`,
                    paddingTop:`${(DeviceUtils.isMobile()===true)?20:0}px`, 
                    }}>
                    <img src={aboutImg} width={window.innerWidth} />  
                </div>:
                <div 
                className="p-0 m-0" 
                style={{width:`${(DeviceUtils.isMobile()===true)?window.innerWidth:window.innerWidth*0.32}px`,float:"right",position:'absolute',top:0,right:0}}>
                    <img src={aboutImg} width={(DeviceUtils.isMobile()===true)?window.innerWidth:window.innerWidth*0.32} /> 
                </div>}

       </HommainView>);
};

export default AboutCenterView;



// WEBPACK FOOTER //
// ./src/components/homepage_new/about/AboutCenterView.js